import { createContext, useContext, useState } from "react";

const SourceContext = createContext(null);

export function SourceProvider({ children }) {
  const [source, setSourceState] = useState(() => sessionStorage.getItem("shipoms_source") || "");
  const setSource = (s) => { sessionStorage.setItem("shipoms_source", s); setSourceState(s); };
  return <SourceContext.Provider value={{ source, setSource }}>{children}</SourceContext.Provider>;
}

export const useSource = () => useContext(SourceContext);
